/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Achievements_Myachievements1Inputs */

const id_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian Saya`)
};

const ms_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian Saya`)
};

const da_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine Achievements`)
};

const de_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Errungenschaften`)
};

const en_us2_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Achievements`)
};

const es_es2_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis logros`)
};

const es_mx2_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis logros`)
};

const fil_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aking mga Achievement`)
};

const fr_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes succès`)
};

const it_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I miei risultati`)
};

const hu_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saját teljesítményeim`)
};

const nl_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn prestaties`)
};

const no_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine prestasjoner`)
};

const pl_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje osiągnięcia`)
};

const pt_br2_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas conquistas`)
};

const pt_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As minhas conquistas`)
};

const ro_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizările mele`)
};

const fi_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omat saavutukseni`)
};

const sv_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mina prestationer`)
};

const vi_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích của tôi`)
};

const tr_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlarım`)
};

const cs_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje úspěchy`)
};

const bg_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моите постижения`)
};

const ru_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои достижения`)
};

const uk_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мої досягнення`)
};

const ar_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنجازاتي`)
};

const hi_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरी उपलब्धियाँ`)
};

const th_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จของฉัน`)
};

const ja_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の実績`)
};

const zh_cn2_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的成就`)
};

const zh_hant1_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的成就`)
};

const ko_profile_achievements_myachievements1 = /** @type {(inputs: Profile_Achievements_Myachievements1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 도전 과제`)
};

/**
* | output |
* | --- |
* | "My Achievements" |
*
* @param {Profile_Achievements_Myachievements1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_achievements_myachievements1 = /** @type {((inputs?: Profile_Achievements_Myachievements1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Achievements_Myachievements1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_achievements_myachievements1(inputs)
	if (locale === "ms") return ms_profile_achievements_myachievements1(inputs)
	if (locale === "da") return da_profile_achievements_myachievements1(inputs)
	if (locale === "de") return de_profile_achievements_myachievements1(inputs)
	if (locale === "en-US") return en_us2_profile_achievements_myachievements1(inputs)
	if (locale === "es-ES") return es_es2_profile_achievements_myachievements1(inputs)
	if (locale === "es-MX") return es_mx2_profile_achievements_myachievements1(inputs)
	if (locale === "fil") return fil_profile_achievements_myachievements1(inputs)
	if (locale === "fr") return fr_profile_achievements_myachievements1(inputs)
	if (locale === "it") return it_profile_achievements_myachievements1(inputs)
	if (locale === "hu") return hu_profile_achievements_myachievements1(inputs)
	if (locale === "nl") return nl_profile_achievements_myachievements1(inputs)
	if (locale === "no") return no_profile_achievements_myachievements1(inputs)
	if (locale === "pl") return pl_profile_achievements_myachievements1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_achievements_myachievements1(inputs)
	if (locale === "pt") return pt_profile_achievements_myachievements1(inputs)
	if (locale === "ro") return ro_profile_achievements_myachievements1(inputs)
	if (locale === "fi") return fi_profile_achievements_myachievements1(inputs)
	if (locale === "sv") return sv_profile_achievements_myachievements1(inputs)
	if (locale === "vi") return vi_profile_achievements_myachievements1(inputs)
	if (locale === "tr") return tr_profile_achievements_myachievements1(inputs)
	if (locale === "cs") return cs_profile_achievements_myachievements1(inputs)
	if (locale === "bg") return bg_profile_achievements_myachievements1(inputs)
	if (locale === "ru") return ru_profile_achievements_myachievements1(inputs)
	if (locale === "uk") return uk_profile_achievements_myachievements1(inputs)
	if (locale === "ar") return ar_profile_achievements_myachievements1(inputs)
	if (locale === "hi") return hi_profile_achievements_myachievements1(inputs)
	if (locale === "th") return th_profile_achievements_myachievements1(inputs)
	if (locale === "ja") return ja_profile_achievements_myachievements1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_achievements_myachievements1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_achievements_myachievements1(inputs)
	return ko_profile_achievements_myachievements1(inputs)
});
export { profile_achievements_myachievements1 as "profile.achievements.myAchievements" }